export const product_type_to_path_map = {
    course: 'courses',
    worksheet: 'worksheets',
    bundle: 'bundles'
};

/**
 *
 * @param {ProductType} product_type
 * @param {String} text_id
 * @returns
 */
export function get_product_path(product_type, text_id) {
    const path = product_type_to_path_map[product_type];

    if (!path) throw new Error(`Unknown product type: ${product_type}`);

    return `/${path}/${text_id}`;
}

/**
 * The product's direct checkout page (see BuyPage.svelte), or '' when it has
 * none: no price for that intent (e.g. a coming-soon course), a redirected
 * product, or a school subscription. The single rule for which buy pages get
 * prerendered and linked, so no link points at a 404.
 * @param {{type: string, slug: string, price?: Price, price_gift?: Price, redirect?: string | null} | null | undefined} product
 * @param {'buy' | 'buy-gift'} purchase_intent
 */
export function get_buy_path(product, purchase_intent = 'buy') {
    const path = product && product_type_to_path_map[product.type];
    const price =
        purchase_intent === 'buy-gift' ? product?.price_gift : product?.price;

    if (!path || !product.slug || !price?.price_id || product.redirect) {
        return '';
    }

    return `/${path}/${product.slug}/${purchase_intent}`;
}
